import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BFF_CONFIG, BFFConfig } from './bff-config.types';
import { BFF_REQUEST } from './bff-error.interceptor';
import { FeatureFlagsResponse } from '@models/featureflags.model';
import { mapApiFeatureFlagsToFe, mapFeKeyToApi } from './feature-flags.mapper';

export const featuresEndpointName = '/v1/features';
export const featureflagStorageKey = 'featureFlags';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BFF_CONFIG) private readonly apiConfig: BFFConfig,
  ) {
  }

  private get apiUrl() {
    return this.apiConfig.BFF.ApiUrl.replace(/\/$/, '');
  }

  fetchFeatureflags(): Observable<FeatureFlagsResponse> {
    // The API is leading: always fetch the current flags rather than serving a (possibly stale)
    // sessionStorage copy. The store persists the response to sessionStorage so it mirrors the API.
    return this.http.get<FeatureFlagsResponse>(`${this.apiUrl}${featuresEndpointName}`, {
      context: new HttpContext().set(BFF_REQUEST, true),
    }).pipe(map((response) => this.mapResponseToFe(response)));
  }

  updateFeatureflags(key: string, value: boolean): Observable<FeatureFlagsResponse> {
    return this.http.put<FeatureFlagsResponse>(`${this.apiUrl}${featuresEndpointName}`, {
      featureFlags: { [mapFeKeyToApi(key)]: value },
    }).pipe(map((response) => this.mapResponseToFe(response)));
  }

  private mapResponseToFe(response: FeatureFlagsResponse): FeatureFlagsResponse {
    return { featureFlags: mapApiFeatureFlagsToFe(response.featureFlags) };
  }
}
